import React from 'react';
import _ from 'lodash';
import { useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import {
  faCog,
  faUniversity,
  faUser,
  faUsers,
  faHome,
  faSignOut,
  faFileAlt,
  faUpload,
  faHistory,
  faBus,
  faReceipt,
  faDatabase,
  faTasks,
  faChartBar
} from '@fortawesome/pro-duotone-svg-icons';
import { userAtom, userPrivilagesAtom } from '../../../atoms/Atoms';
import MainPage from '../../shared-components/main-page/MainPage';
import { H1 } from '../../shared-components/typography/Title';
import HomeCard from './shared-components/HomeCard';
import envConfig from '../../../envConfig';

function Home() {
  const user = useRecoilValue(userAtom);
  const { t } = useTranslation();
  const userPrivilages = useRecoilValue(userPrivilagesAtom);

  return (
    <MainPage>
      <H1 className="mt-4 mb-4" text={t('home_intro')} />
      <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {userPrivilages?.hasGlobalPrivilages && envConfig.ServerConfigurationString && (
          <HomeCard
            icon={faCog}
            title={t('server_config')}
            description={t('server_config_desc')}
            route="/serverconfig"
          />
        )}
        {/* {userPrivilages?.hasAdminPrivilages && (
          <HomeCard
            icon={faUniversity}
            title={t('corporations')}
            description={t('corporations_desc')}
            route="/corporations"
          />
        )} */}
        {userPrivilages?.hasAdminPrivilages && (
          <>
            <HomeCard
              icon={faFileAlt}
              title={t('storage_file_processes')}
              description={t('storage_file_processes_desc')}
              route="/fileprocesses"
            />
          </>
        )}
        {userPrivilages?.hasCustomerSupportPrivilages && (
          <HomeCard
            icon={faUsers}
            title={t('users')}
            description={t('users_desc')}
            route="/users"
          />
        )}
        <HomeCard
          icon={faChartBar}
          title={t('charts')}
          description={t('charts_desc')}
          route="/reports/charts"
        />
        <HomeCard
          icon={faDatabase}
          title={t('on_hand_inventory_report')}
          description={t('inventory_desc')}
          route="/reports/inventory"
        />
        {/* <HomeCard
          icon={faDatabase}
          title={t('nonserialized_inventory_on_hand')}
          description={t('parts_inventory_desc')}
          route="/reports/partsInventory"
        /> */}
        <HomeCard
          icon={faDatabase}
          title={t('receiving_report')}
          description={t('receiving_report_desc')}
          route="/reports/receivingReport"
        />
        <HomeCard
          icon={faDatabase}
          title={t('dispatch_report')}
          description={t('sales_order_with_asset_detail_desc')}
          route="/reports/orders/assetDetail"
        />
        <HomeCard
          icon={faDatabase}
          title={t('dispatch_order_status')}
          description={t('sales_order_by_status_desc')}
          route="/reports/orders/status"
        />
      </div>
    </MainPage>
  );
}

export default Home;
